import React, { useState, useEffect } from "react";
import { MenuItem, Select, FormControl } from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import EmailIcon from "@mui/icons-material/Email";
import PublicIcon from "@mui/icons-material/Public";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InfoIcon from "@mui/icons-material/Info";
import Gmail from "../../Assets/img/icons/Gmail.svg";
import Outlook from "../../Assets/img/icons/outlook.svg";
import Apple from "../../Assets/img/icons/apple.svg";
import Email from "../../Assets/img/icons/email.svg";
import QRCode from "qrcode.react";
import axios from 'axios';
// import { Height } from '@mui/icons-material';
// import { ReactComponent as CardWaveWithoutShadow } from '../../Assets/img/card/waveline new.svg'
// import CompanyLogo from '../../Assets/img/card/wipro-logo.jpg'
// import CompanyLogo from '../../Assets/img/Neoin-logo.png'
import "../../Assets/css/card.css";
// import DefaultProfile from "../../Assets/img/Default-Profile.png"
// import 'rsuite/dist/rsuite.min.css';
// import Steps from 'rsuite/Steps';
// import { ReactComponent as NeocardzWave } from "../../Assets/img/card/Neocardz wave.svg"
// import NeocardzWave from '../Utilities/NeocardzWave';
import CardWaveStd from "../Utilities/CardWaveStd";
import CardWaveSmile from "../Utilities/CardWaveSmile2";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DomToImage from "dom-to-image";
import SignPhoneIcon from "../../Assets/img/card/Smartphone-icon.png";
import SignEmailIcon from "../../Assets/img/card/Email-icon.png";
import SignWebsiteIcon from "../../Assets/img/card/Globe-icon.png";
import SignLocationIcon from "../../Assets/img/card/Location-icon.png";
import { useUserDetailContext } from "../UserDetailContext";
import DefaultProfileBg from "../../Assets/img/card/profilebg.png";
import { Grid, Stepper, Step, StepLabel, Box } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import loaderGif from '../../Assets/img/icons/Animation - 1718370478484.gif'
import EmailSignatureSkeleton from "../LoadingSkeleton/EmailSignatureSkeleton";
import { useQuantityContext } from "../QuantityContext";
import { motion } from "framer-motion"

const Lightbox = ({
  isOpen,
  handleClose,
  emailSignature,
  selectedCard,
  objectId,
  renderCardContent,
}) => {
  const { handleSuccess, handleFailure } = useQuantityContext();
  const [activeMenu, setActiveMenu] = useState("inbox");
  const [showGenerate, setShowGenerate] = useState(true);
  const [generatedSignature, setGeneratedSignature] = useState(null);

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
  };

  const handleGenerateSignature = () => {
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = emailSignature;
    tempContainer.style.display = "inline-block";
    document.body.appendChild(tempContainer);

    const qrDynamic = tempContainer.querySelector(
      'img[src*="api.qrserver.com"]'
    );
    if (qrDynamic !== null) {
      qrDynamic.onload = () => {
        handleConvertImage(tempContainer);
      };

      qrDynamic.onerror = () => {
        console.error("Failed to load the QR code image.");
        document.body.removeChild(tempContainer);
      };
    } else {
      handleConvertImage(tempContainer);
    }
  };

  // const handleConvertImage = (tempContainer) => {
  //   DomToImage.toBlob(tempContainer)
  //     .then((blob) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(blob);
  //       reader.onloadend = () => {
  //         const base64data = reader.result;
  //         const clickableHTML = `
  //           <a href="${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}" target="_blank" rel="noreferrer">
  //             <img src="${base64data}" alt="Email Signature" />
  //           </a>
  //         `;
  //         setGeneratedSignature(clickableHTML);
  //         setShowGenerate(false);
  //       };
  //     })
  //     .catch((error) => {
  //       console.error("Failed to convert HTML to image: ", error);
  //     })
  //     .finally(() => {
  //       document.body.removeChild(tempContainer); // Comment this line for debugging
  //     });
  // };


  const handleConvertImage = async (tempContainer) => {
    try {
      // Convert the HTML content to an image blob using DomToImage
      const blob = await DomToImage.toBlob(tempContainer);

      // Create a FormData object to upload the image to the backend
      const formData = new FormData();
      formData.append('file', blob, 'signature-image.png');  // Add file to form data

      // Send the image to the backend for uploading to Azure Blob Storage
      const response = await axios.post('/api/v1/email-signature/generate-image-url', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${objectId}`,
          'x-api-key': process.env.API_KEY
        },
      });

      if (response.data?.data && response.data?.data?.url) {
        const imageUrl = response.data?.data?.url;
        // Once the image is uploaded, use the returned URL to create the clickable signature
        const clickableHTML = `
        <a href="${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}" target="_blank" rel="noreferrer">
          <img src="${imageUrl}" alt="Email Signature" />
        </a>
      `;

        // Set the generated signature in state
        setGeneratedSignature(clickableHTML);
        setShowGenerate(false);
        handleSuccess("Email Signature Generated!", "success", 3000);
      } else {
        console.error('Failed to generate blob URL from the server.');
        handleFailure("Failed to generate Email Signature. Try again later.");
      }
    } catch (error) {
      console.error("Failed to convert HTML to image and upload: ", error);
      handleFailure("Failed to generate Email Signature. Try again later.");
    } finally {
      // Clean up or reset if needed
      document.body.removeChild(tempContainer); // Comment this line for debugging
    }
  };


  // const copyToClipboard = async (html) => {
  //   if (!generatedSignature) {
  //     console.error("No generated signature to copy", generatedSignature);
  //     return;
  //   }
  //   try {
  //     const blob = new Blob([html], { type: "text/html" });
  //     const item = new ClipboardItem({ "text/html": blob });
  //     await navigator.clipboard.write([item]);
  //     // alert('Signature copied to clipboard!');
  //     // throw new Error("Use Fallback");
  //   } catch (error) {
  //     console.log("Failed to copy HTML to clipboard: ", error);
  //     fallbackCopyImage(html);
  //   } finally {
  //     setShowGenerate(true);
  //   }
  // };


  const copyToClipboard = async (html) => {
    if (!generatedSignature) {
      console.error("No generated signature to copy", generatedSignature);
      return;
    }
    try {
      const blob = new Blob([html], { type: "text/html" });
      const item = new ClipboardItem({ "text/html": blob });
      await navigator.clipboard.write([item]);
      handleSuccess("Email Signature Copied!", "success", 3000);
    } catch (error) {
      console.log("Failed to copy HTML to clipboard: ", error);
      fallbackCopyImage(html);
    } finally {
      setShowGenerate(true);
    }
  };

  const fallbackCopyImage = (html) => {
    try {
      const tempElement = document.createElement("div");
      tempElement.innerHTML = html;
      document.body.appendChild(tempElement);

      window.getSelection().removeAllRanges();
      const range = document.createRange();
      range.selectNode(tempElement);
      window.getSelection().addRange(range);
      const success = document.execCommand("copy");
      window.getSelection().removeAllRanges();

      document.body.removeChild(tempElement);
      if (success) {
        console.log("Signature copied ");
        handleSuccess("Email Signature Copied!", "success", 3000);
      }
      else console.log("Failed to copy");
      // alert('Failed to copy Signature. Try a different Browser.')
    } catch (error) {
      console.log("Try failed with error", error);
      handleFailure("Failed to copy Email Signature. Try again later.");
    }
  };

  return (
    <div className={`lightbox ${isOpen ? "open" : ""}`}>
      <div className="content">
        <h2>How to add a signature to your emails</h2>
        <span className="sub-tit-email">
          Select your email provider below and follow to the steps to add your
          signature
        </span>
        <button type="button" className="lightbox__close" onClick={handleClose}>
          &times;
        </button>

        <div className="mt-20px menu">
          <div
            onClick={() => handleMenuClick("inbox")}
            className={`menu-item ${activeMenu === "inbox" ? "active" : ""}`}
          >
            <div className="container-gift">
              <img src={Gmail} alt="Gmail" />
              <span>Gmail</span>
            </div>
          </div>
          <div
            onClick={() => handleMenuClick("web_outbox")}
            className={`menu-item ${activeMenu === "web_outbox" ? "active" : ""
              }`}
          >
            <div className="container-gift">
              <img src={Outlook} alt="Outlook" />
              <span>Outlook Web</span>
            </div>
          </div>
          <div
            onClick={() => handleMenuClick("desktop_outbox")}
            className={`menu-item ${activeMenu === "desktop_outbox" ? "active" : ""
              }`}
          >
            <div className="container-gift">
              <img src={Outlook} alt="Outlook" />
              <span>Outlook Desktop</span>
            </div>
          </div>
          <div
            onClick={() => handleMenuClick("web_apple")}
            className={`menu-item ${activeMenu === "web_apple" ? "active" : ""
              }`}
          >
            <div className="container-gift">
              <img src={Apple} alt="Apple" />
              <span>Mail</span>
            </div>
          </div>

          <div
            onClick={() => handleMenuClick("desktop_apple")}
            className={`menu-item ${activeMenu === "desktop_apple" ? "active" : ""
              }`}
          >
            <div className="container-gift">
              <img src={Apple} alt="Apple" />
              <span>iPhone/ iPad</span>
            </div>
          </div>

          <div
            onClick={() => handleMenuClick("others")}
            className={`menu-item ${activeMenu === "others" ? "active" : ""}`}
          >
            <div className="container-gift">
              <img src={Email} alt="Email" />
              <span>Others</span>
            </div>
          </div>
        </div>

        <div className="rsuite-container">
          <Grid container spacing={3}>
            <Grid item xs={5} md={7} lg={7}>
              <div className="ml-20px content-for-Email">
                {activeMenu === "inbox" && (
                  <div className="menu-content">
                    <Stepper
                      className="mail-sign-stepper"
                      orientation="vertical"
                    >
                      <Step>
                        <StepLabel className="custom-step-icon">
                          <br />
                        </StepLabel>
                      </Step>
                      <Step>
                        <StepLabel className="custom-step-icon">
                          STEP 1
                        </StepLabel>
                        <div className="description-content-1">
                          Generate and copy your signature's HTML
                          {showGenerate ? (
                            <button
                              className="ml-20px Add-to-Email"
                              onClick={handleGenerateSignature}
                            >
                              Generate Signature
                            </button>
                          ) : (
                            <button
                              className="ml-20px Add-to-Email"
                              onClick={() =>
                                copyToClipboard(generatedSignature)
                              }
                            >
                              Copy Signature
                            </button>
                          )}
                        </div>
                      </Step>
                      <Step>
                        <StepLabel className="custom-step-icon">
                          STEP 2
                        </StepLabel>
                        <div className="description-content-1">
                          Within your Gmail account, click the gear icon on the
                          top right, select the “See all settings” option and
                          scroll down to the “Signature” section.
                        </div>
                      </Step>
                      <Step>
                        <StepLabel className="custom-step-icon">
                          STEP 3
                        </StepLabel>
                        <div className="description-content-1">
                          Select the “Create new” option and paste your email
                          signature into the text box
                        </div>
                      </Step>
                      <Step>
                        <StepLabel className="custom-step-icon">
                          STEP 4
                        </StepLabel>
                        <div className="description-content-1">
                          In the “Signature Defaults” subsection, select your
                          newly created signature as default and then scroll
                          down to the very bottom of the page and select the
                          “Save” button
                        </div>
                      </Step>
                    </Stepper>
                  </div>
                )}
                {activeMenu === "web_outbox" && (
                  <div className="menu-content">
                    <Stepper
                      className="mail-sign-stepper"
                      orientation="vertical"
                    >
                      <Step>
                        <StepLabel className="custom-step-icon">
                          <br />
                        </StepLabel>
                      </Step>
                      <Step>
                        <StepLabel className="custom-step-icon">
                          STEP 1
                        </StepLabel>
                        <div className="description-content-1">
                          Generate and copy your signature's HTML
                          {/* <button className='ml-20px Add-to-Email' onClick={handleCopySignature}>Copy Signature</button> */}
                        </div>
                      </Step>
                      <Step>
                        <StepLabel className="custom-step-icon">
                          STEP 2
                        </StepLabel>
                        <div className="description-content-1">
                          Within your Outlook account, select the gear icon in
                          the top right followed by the “Compose and reply”
                          option just below the “Layout” tab at the top.
                        </div>
                      </Step>
                      <Step>
                        <StepLabel className="custom-step-icon">
                          STEP 3
                        </StepLabel>
                        <div className="description-content-1">
                          Click on “New signature”, provide a name for your
                          signature and then paste your email signature into the
                          larger text box
                        </div>
                      </Step>
                      <Step>
                        <StepLabel className="custom-step-icon">
                          STEP 4
                        </StepLabel>
                        <div className="description-content-1">
                          In the “Select default signatures” subsection below,
                          choose your newly created signature as default and
                          click the blue save button in the bottom right Copy
                          Signature
                        </div>
                      </Step>
                    </Stepper>
                  </div>
                )}
                {activeMenu === "desktop_outbox" && (
                  <div className="menu-content">
                    <Stepper
                      className="mail-sign-stepper"
                      orientation="vertical"
                    >
                      <Step>
                        <StepLabel>
                          <br />
                        </StepLabel>
                      </Step>
                      <Step>
                        <StepLabel>STEP 1</StepLabel>
                        <div className="description-content-1">
                          Generate and copy your signature's HTML
                          {/* <button className='ml-20px Add-to-Email' onClick={handleCopySignature}>Copy Signature</button> */}
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 2</StepLabel>
                        <div className="description-content-1">
                          (Windows) Within Outlook, select the “File” in the top
                          left corner, followed by “Options” then “Mail” (Mac)
                          Select “Outlook” in the top left corner, then
                          “Preferences”.
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 3</StepLabel>
                        <div className="description-content-1">
                          Click on “Signatures” in the menu/popup.
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 4</StepLabel>
                        <div className="description-content-1">
                          Set your newly created signature as default Copy
                          Signature.
                        </div>
                      </Step>
                    </Stepper>
                  </div>
                )}
                {activeMenu === "web_apple" && (
                  <div className="menu-content">
                    <Stepper
                      className="mail-sign-stepper"
                      orientation="vertical"
                    >
                      <Step>
                        <StepLabel>
                          <br />
                        </StepLabel>
                      </Step>
                      <Step>
                        <StepLabel>STEP 1</StepLabel>
                        <div className="description-content-1">
                          Generate and copy your signature's HTML
                          {/* <button className='ml-20px Add-to-Email' onClick={handleCopySignature}>Copy Signature</button> */}
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 2</StepLabel>
                        <div className="description-content-1">
                          Within the mail app, select “Mail” in the top left
                          corner, followed by “Preferences” and then click on
                          the “Signatures” tab.
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 3</StepLabel>
                        <div className="description-content-1">
                          Paste your email signature into the text box on the
                          right side and make sure the “Always match my default
                          message font” setting is unselected. If you don’t have
                          any existing signatures you will have to first create
                          one by clicking on the “+” sign at the bottom.
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 4</StepLabel>
                        <div className="description-content-1">
                          Open the “Choose Signature” popup and then select your
                          newly created signature.
                        </div>
                      </Step>
                    </Stepper>

                    <div className="warning-apple">
                      <div className="digital-card-line">
                        <InfoIcon />
                        <div className="warning">
                          {" "}
                          Your email signature won't be fully visible in the
                          preview after your paste it in. It will still come
                          through correctly however, when sending emails
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeMenu === "desktop_apple" && (
                  <div className="menu-content">
                    <Stepper
                      className="mail-sign-stepper"
                      orientation="vertical"
                    >
                      <Step>
                        <StepLabel>
                          <br />
                        </StepLabel>
                      </Step>
                      <Step>
                        <StepLabel>STEP 1</StepLabel>
                        <div className="description-content-1">
                          Generate and copy your signature's HTML
                          {/* <button className='ml-20px Add-to-Email' onClick={handleCopySignature}>Copy Signature</button> */}
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 2</StepLabel>
                        <div className="description-content-1">
                          Open the "Settings" app.
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 3</StepLabel>
                        <div className="description-content-1">
                          Scroll down and choose "Mail".
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 4</StepLabel>
                        <div className="description-content-1">
                          Scroll down and tap "Signature".
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 5</StepLabel>
                        <div className="description-content-1">
                          Paste the Neoin signature into the appropriate
                          account.
                        </div>
                      </Step>
                    </Stepper>
                    <div className="warning-apple">
                      <div className="digital-card-line">
                        <InfoIcon />
                        <div className="warning">
                          {" "}
                          Your email signature won't be fully visible in the
                          preview after your paste it in. It will still come
                          through correctly however, when sending emails
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeMenu === "others" && (
                  <div className="menu-content">
                    <Stepper
                      className="mail-sign-stepper"
                      orientation="vertical"
                    >
                      <Step>
                        <StepLabel></StepLabel>
                      </Step>
                      <Step>
                        <StepLabel>STEP 1</StepLabel>
                        <div className="description-content-1">
                          Generate and copy your signature's HTML
                          {/* <button className='ml-20px Add-to-Email' onClick={handleCopySignature}>Copy Signature</button> */}
                        </div>
                      </Step>
                      <Step>
                        <StepLabel>STEP 2</StepLabel>
                        <div className="description-content-1">
                          You can add an email signature directly within an
                          email or in Settings for most email platforms.
                        </div>
                      </Step>
                    </Stepper>
                  </div>
                )}
              </div>
            </Grid>
            <Grid item xs={5} md={5} lg={5}>
              <div className="second-part flex-center">
                <div className="right-div">{renderCardContent()}</div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

const DigitalIdentity = () => {
  const location = useLocation();
  const { someProp } = location.state || {};
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };
  const { userDetails, cardDetailsAll, cardStylesAll, cards } = useUserDetailContext();
  // State to manage active link
  console.log("ALL CARDS INSIDE THE DigitalIdentity", cards);

  // console.log("cardDetailsAll", cardDetailsAll);

  const [activeLink, setActiveLink] = useState("content1");
  const [loading, setLoading] = useState(true);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const [userProfile, setUserProfile] = useState(null);

  const toggleLightbox = () => {
    setLightboxOpen(!lightboxOpen);
  };

  const handleCloseLightbox = () => {
    setLightboxOpen(false);
  };

  const handleClick = () => {
    toggleLightbox();
  };

  useEffect(() => {
    if (cards.length > 0) {
      setLoading(false);
    }
  }, [cards]);

  // State variables for customizations
  const [fontColor, setFontColor] = useState("#0044C6"); // Default font color
  const [borderColor, setBorderColor] = useState("#ccc"); // Default border color
  const [fontStyle, setFontStyle] = useState("Lato"); // Default font style

  // Function to handle click on links
  const handleLinkClick = (content) => {
    setActiveLink(content);
  };

  // Predefined color options
  const predefinedFontColors = ["#000", "#B0B0B0", "#FF9800", "#828593"];
  const predefinedBorderColors = ["#757575", "#0044C6", "#FF82AC", "#00DBE4"];

  const fontStyleOptions = [
    { label: "Default", value: "Lato" },
    { label: "Poppins", value: "Poppins, sans-serif" },
    { label: "Roboto", value: "Roboto, sans-serif" },
  ];

  // Function to handle selection of font color
  const handleFontColorChange = (color) => {
    setFontColor(color);
  };

  // Function to handle selection of border color
  const handleBorderColorChange = (color) => {
    setBorderColor(color);
  };

  const [selectedCard, setSelectedCard] = useState(someProp || "Personal");
  const [validCards, setValidCards] = useState([]);

  // console.log("Selected Card is", selectedCard);

  const [cardDetailsForProfile, setCardDetailsForProfile] = useState({
    User_ID: objectId,
    profile_pic: "",
    logo: "",
    designation: "Profession",
  });

  const [cardDetailsForPersonal, setCardDetailsForPersonal] = useState({
    User_ID: objectId,
    profile_pic: "",
    logo: "",
    title: "Title",
  });

  const [cardDetailsForStudent, setCardDetailsForStudent] = useState({
    User_ID: objectId,
    profile_pic: "",
    logo: "",
    designation: "",
    title: "Title",
  });

  const [cardDetailsForGenZ, setCardDetailsForGenZ] = useState({
    User_ID: objectId,
    profile_pic: "",
    logo: "",
    designation: "Profession",
    title: "Title",
  });

  const cardStylesProperties = {
    font: "",
    style: "",
    colorPrimary: "",
    colorSecondary: "",
    colorTitle: "",
    colorLayout: "#0044C6",
    bgColor: "#ffffff",
  };

  const [website, setWebsite] = useState("");
  const [CardProfession, setCardProfession] = useState(
    cardDetailsForPersonal?.title || DefaultProfileBg
  );
  const [CardProfilePic, setCardProfilePic] = useState(
    cardDetailsForPersonal?.profile_pic || DefaultProfileBg
  );
  const [cardLogo, setSelectedcardLogo] = useState(
    cardDetailsForPersonal?.logo || DefaultProfileBg
  );

  // const convertToBase64 = async (url) => {
  //     const response = await fetch(url);
  //   const blob = await response.blob();
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => resolve(reader.result);
  //     reader.onerror = reject;
  //     reader.readAsDataURL(blob);
  //   });
  // };


  const convertToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("convertToBase64 error:", error);
      throw error; // Re-throw to handle it in the calling function
    }
  };


  const handleCardClick = async (cardType) => {
    setSelectedCard(cardType);
    console.log("PARTICULAR CARD DATA", cardDetailsAll);
    const CardDetailsFilterByName = cardDetailsAll?.find((state) => state?.CardName === cardType);
    const CardDeailsForStyles = cardStylesAll?.find((state) => state?.CardName === cardType);
    // const data = cardDetailsAll[cardType];
    const data = CardDetailsFilterByName;
    const profilePicture = data?.profile_pic || DefaultProfileBg;
    const logo = data?.logo || DefaultProfileBg;
    setWebsite(data?.company_website || "");
    const profilePicBase64 = await convertToBase64(profilePicture);
    setCardProfilePic(profilePicBase64);

    // const logoBase64 = await convertToBase64(logo);
    setSelectedcardLogo(logo);

    const Profession =
      data?.CardType !== "Professional" || cardType !== "Customize_Professional"
        ? data?.title
        : data?.designation;
    setCardProfession(Profession || "");
  };

  useEffect(() => {
    handleCardClick("Personal");
  }, [cardDetailsAll]);

  const generateEmailSignature = () => {
    let emailSignature = "";
    // let profilePicture = userDetails.proFile;

    let cardType = "";
    if (selectedCard === "Professional") cardType = "Business Card";
    else if (selectedCard === "Student") cardType = "Student Card";
    else if (selectedCard === "GenZ") cardType = "GenZ Card";
    else if (selectedCard === "Personal") cardType = "Personal Card";
    else cardType = `${selectedCard} ` + "Card";

    if (activeLink === "content1") {
      emailSignature = `<a href="${process.env.REACT_APP_CARD_URL
        }/digital-identity/${selectedCard}/${objectId}" rel="noopener noreferrer">
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; padding: 20px; background-color: #FFFFFF; border-radius: 5px; max-width: 400px; overflow: hidden; border: 1px solid ${borderColor}; min-width: 300px; margin: 5px;">
        <div style="flex: 1; padding-right: 20px;">
            <h2 style="font-size: 18px; color: ${fontColor}; margin-bottom: 5px; font-weight: 700">${userDetails.name
        }</h2>
            <p style="margin-bottom: 10px; margin-top: 0; color: #00000091;">${CardProfession}</p>
            <div style="display: flex; justify-content: space-between; align-items: center">
                <div style="height: auto; max-width: 150px;">
                    <img src="${CardProfilePic}" alt="Profile Picture"
                        style="margin-bottom: 10px; display: block; border-radius: 50%; border: 5px solid #E5E5E5;"
                        width="100" height="100">
                        ${selectedCard !== "Personal"
          ? `<div style="max-width: 150px; max-height: 150px; height: 42px; width: 42px; position: relative; border: 1px solid #E5E5E5; border-radius: 50%; left: 75px; top: -50px; background: #ffffff; display: flex; justify-content: center; align-items: center; overflow: hidden">
                            <img src="${cardLogo}" alt="Company Logo" style="width: 95%; height: 95%; object-fit: contain ">
                          </div>`
          : ""
        }
                </div>
                <div style="text-align: center;">
                    <img src="https://api.qrserver.com/v1/create-qr-code/?data=${process.env.REACT_APP_CARD_URL
        }/digital-identity/${selectedCard}/${objectId}"
                        alt="QR Code" style="width: 90px; height: 90px; max-width: 150px;">
                    <p style="font-size: 14px; color: #0044C6; margin-top: 5px;">${cardType}</p>
                </div>
            </div>
        </div>
        </div>
</a>`;
    } else if (activeLink === "content2") {
      emailSignature = `<a href="${process.env.REACT_APP_CARD_URL
        }/digital-identity/${selectedCard}/${objectId}" rel="noopener noreferrer">
    <div
        style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; padding: 20px; background-color: #fff; border-radius: 5px; border: 1px solid ${borderColor}; display: flex; justify-content: space-between; max-width: 500px; overflow: hidden; margin: 5px;">

        <!-- Left Half -->
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">

            <!-- Profile Picture and Company Logo -->
            <div style="height: auto; max-width: 150px;">
                    <img src="${CardProfilePic}" alt="Profile Picture"
                        style="margin-bottom: 10px; display: block; border-radius: 50%; border: 5px solid #E5E5E5;"
                        width="100" height="100">
                        ${selectedCard !== "Personal"
          ? `<div style="max-width: 150px; max-height: 150px; height: 42px; width: 42px; position: relative; border: 1px solid #E5E5E5; border-radius: 50%; left: 75px; top: -50px; background: #ffffff; display: flex; justify-content: center; align-items: center; overflow: hidden">
                          <img src="${cardLogo}" alt="Company Logo" style="width: 95%; height: 95%; object-fit: contain">
                        </div>`
          : `<div style="margin-top: 30px;" ></div>`
        }                        
              </div>

            <!-- QR Code Scan Image -->
            <img src="https://api.qrserver.com/v1/create-qr-code/?data=${process.env.REACT_APP_CARD_URL
        }/digital-identity/${selectedCard}/${objectId}"
                alt="QR Code" style="display: block; margin-top: -20px; max-width: 80px; max-height: 80px;">

            <!-- Type -->
            <p style="font-size: 14px; color: rgb(0, 68, 198); margin-bottom: 0;">${cardType}</p>
        </div>

        <!-- Right Half -->
        <div style="display: flex; flex-direction: column; justify-content: flex-start; margin-left: 20px; padding-top: 30px">

            <!-- Name and profession -->
            <div style="margin-bottom: 40px;">
            <h2 style="font-size: 18px; color:${fontColor}; margin-bottom: 5px; font-weight: 700">${userDetails.name
        }</h2>
            <p style="margin-bottom: 10px; margin-top: 0; color: #00000091;">${CardProfession}</p>
            </div>

            <!-- Phone -->
            <span style="display: flex; text-align: left; margin-top: 5px; border-bottom: 1px solid #0000001F; align-items: center">
              <div style="margin-bottom: 1px; margin-right: 5px; display: flex; align-items: center;">
                <img src=${SignPhoneIcon} alt="E!" >
              </div>
              <p style="margin: 0;">${userDetails.phone}</p>
            </span>

            <!-- Email -->
            <span style="display: flex; text-align: left; margin-top: 5px; border-bottom: 1px solid #0000001F;  align-items: center">
              <div style="margin-bottom: 1px; margin-right: 5px; display: flex; align-items: center;">
                <img src=${SignEmailIcon} alt="P!" > 
              </div>
              <p style="margin: 0;">${userDetails.email}</p>
            </span>

            <!-- Website -->
            <span style="display: flex; text-align: left; margin-top: 5px; border-bottom: 1px solid #0000001F; align-items: center">
              <div style="margin-bottom: 1px; margin-right: 5px; display: flex; align-items: center;">
                <img src=${SignWebsiteIcon} alt="W!" > 
              </div>
              <p style="margin: 0;">${website}</p>
            </span>

            <!-- Location -->
            <span style="display: flex; text-align: left; margin-top: 5px; border-bottom: 1px solid #0000001F; align-items: center">
              <div style="margin-bottom: 1px; margin-right: 5px; display: flex; align-items: center;">
                <img src=${SignLocationIcon} alt="L!" > 
              </div>
              <p style="margin: 0;">${userDetails.location}</p>
            </span>

        </div>
    </div>
</a>    
    `;
    } else if (activeLink === "content3") {
      emailSignature = `
      <a href="${process.env.REACT_APP_CARD_URL
        }/digital-identity/${selectedCard}/${objectId}" rel="noopener noreferrer">
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; padding: 20px; background-color: #fff; border-radius: 5px; border: 1px solid ${borderColor}; display: flex; align-items: flex-start; max-width: 400px; overflow: hidden; margin: 5px;">

        <!-- Left Half (Profile Picture and Logo) -->
        <div style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: flex-start; margin-right: 10px;">
            <div style="display: flex; flex-direction: column;">
            <div>

            <!-- Profile Picture -->
            <!-- Profile Picture and Company Logo -->
            <div style="height: auto; max-width: 150px; max-height: 120px;">
                    <img src="${CardProfilePic}" alt="Profile Picture"
                        style="margin-bottom: 10px; display: block; border-radius: 50%; border: 5px solid #E5E5E5;"
                        width="100" height="100">
                        ${selectedCard !== "Personal"
          ? `<div style="max-width: 150px; max-height: 150px; height: 42px; width: 42px; position: relative; border: 1px solid #E5E5E5; border-radius: 50%; left: 75px; top: -50px; background: #ffffff; display: flex; justify-content: center; align-items: center; overflow: hidden">
                          <img src="${cardLogo}" alt="Company Logo" style="width: 95%; height: 95%; object-fit: contain">
                        </div>`
          : ""
        }
              </div>
                </div>
                  <span style="font-size: 14px; color: rgb(0, 68, 198); margin-bottom: 0; text-align: center">${cardType}</span>
            </div>
        </div>

        <!-- Right Half (Name and Profession) -->
        <div style="flex: 1 1 auto; text-align: left; flex-direction: column; justify-content: space-between;">
          <div style="display: flex; flex-direction: column; margin-top: 25px;">
          <h2 style="font-size: 18px; color: ${fontColor}; margin-bottom: 5px; margin-top: 0; font-weight: 700">${userDetails.name
        }</h2>
          <p style="margin-bottom: 10px; margin-top: 0; color: #00000091;">${CardProfession}</p>
          </div>

          <div style="text-align: right;">
          <a href="#" style="font-size: 14px; color: rgb(0, 68, 198); border-bottom: 1px solid rgba(0, 68, 198, 1); font-weight: 600; position: relative; bottom: -42px; text-align: right"> Save Contact </a>
          </div>
        </div>

    </div>
</a>    
    `;
    } else if (activeLink === "content4") {
      emailSignature = `
      <a href="${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}" rel="noopener noreferrer">
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; padding: 20px; background-color: #fff; border-radius: 5px; border: 1px solid ${borderColor}; min-width: 300px; max-width: 400px; overflow: hidden; margin: 5px;">
        <div style="display: flex; align-items: center;">
    
          <!-- Scanner Image and Business Card (Left) -->
          <div style="flex: 30% 1;">
            <div className='Scanner-image left' style="margin-right: 5px;">
              <img src="https://api.qrserver.com/v1/create-qr-code/?data=${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}" alt="Scanner Image" class='container-gift-1' style="max-width: 100px; max-height: 100px; margin-bottom: 10px;">
              <span className='business-card left' style="font-size: 11px; font-weight: 400; line-height: 13.2px; text-align: center; color: rgb(0, 68, 198);">${cardType}</span>
            </div>
          </div>
    
          <!-- Name and Profession (Center) -->
          <div className='default-card profilelogo' style="flex: 40% 1; text-align: left; display: flex; align-items: flex-start; flex-direction: column;">
            <h2 className='esign-Name' style="margin: 0; font-size: 18px; color: ${fontColor}; font-weight: 700">${userDetails.name}</h2>
            <span className='Profession' style="margin: 0; color: rgba(0, 0, 0, 0.57); line-height: 17px; font-size: 14px; display: block; text-align: left; font-weight: 400;">${CardProfession}</span>
          </div>
    
          <!-- Company Logo and Save Contact Button (Right) -->
          <div style="text-align: right;">
            <!-- Company Logo -->
            <div className='cir-container' style="width: 64px; height: 64px; border-radius: 50%; border: 0.5px solid #E5E5E5; background: #FFFFFF; display: flex; justify-content: center; align-items: center;">
              <img src="${cardLogo}" alt="Company Logo" className='new' style="width: 47px; height: 36px;">
            </div>
          </div>
            </div>
            <!-- Save Contact Button -->
            <div className='save-design' style="margin-top: 10px; text-align:right;">
              <span className='save-Contact' style="width: 100px; height: 14px; size: 12px; color: rgb(0, 68, 198); border-bottom: 1px solid rgb(0, 68, 198); font-weight: 600;">Save Contact</span>
            </div>
        </div>
        </a>
      `;
    } else if (activeLink === "content5") {
      emailSignature = `
      <a href="${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}" rel="noopener noreferrer">
        <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; border-radius: 5px; padding: 30px; border: 1px solid ${borderColor}; max-width: 400px; overflow: hidden; margin: 5px">
          <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
            <div className='Scanner-image left'>
              <img src="https://api.qrserver.com/v1/create-qr-code/?data=${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}" alt="Scanner Image" class='container-gift-1' style="max-width: 100px; height: auto; margin-bottom: 10px;">
              <span className='business-card left' style="font-size: 11px; font-weight: 400; line-height: 13.2px; text-align: center; color: rgb(0, 68, 198);">${cardType}</span>
            </div>
            <span> <a href="#" className='save-Contact' style="width: 100px; height: 14px; size: 12px; color: rgb(0, 68, 198); font-weight: 600; text-decoration: underline; margin-top: 20px;"> Save Contact </a> </span>
          </div>
        </div>
      </a>    
    `;
    } else if (activeLink === "content6") {
      emailSignature = `
      <a href="${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}" rel="noopener noreferrer">
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; padding: 20px; background-color: #fff; border-radius: 5px; border: 1px solid ${borderColor}; display: flex; align-items: center; max-width: 400px; overflow: hidden; margin: 5px;">

        <!-- Left Half (Profile Picture and Logo) -->
        <div style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: flex-start; margin-right: 10px;">
            <div style="display: flex; flex-direction: column;">
            <!-- Profile Picture -->
              <div style="margin-right: 5px; border-radius: 50%; border: 5px solid #E5E5E5; display: flex; justify-content: center; align-items: center; background: #ffffff; height: 100px; width: 100px; overflow: hidden">
                <img src="${cardLogo}" alt="Profile Picture"
                style="display: block; max-width: 100px; height: 40px; width: 75px;">
              </div>
                  <span style="font-size: 14px; color: rgb(0, 68, 198); margin-bottom: 0; text-align: center;  margin-top: 20px;">${cardType}</span>
            </div>
        </div>

        <!-- Right Half (Name and Profession) -->
        <div style="flex: 1 1 auto; text-align: left; flex-direction: column; justify-content: space-between;">
          <div style="display: flex; flex-direction: column; margin-bottom: 20px;">
          <h2 style="font-size: 18px; color:${fontColor}; margin-bottom: 5px; font-weight: 700;">${userDetails.name}</h2>
          <p style="margin-bottom: 10px; margin-top: 0; color: #00000091;">${CardProfession}</p>
          </div>

          <div style="text-align: right;">
          <a href="#" style="font-size: 14px; color: rgb(0, 68, 198); border-bottom: 1px solid rgba(0, 68, 198, 1); font-weight: 600; position: relative; bottom: -21px; text-align: right"> Save Contact </a>
          </div>
        </div>

    </div>
</a>    
    `;
    } else if (activeLink === "content7") {
      emailSignature = `
      <a href="${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}" rel="noopener noreferrer">
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; border-radius: 5px; border: 1px solid ${borderColor}; max-width: 400px; overflow: hidden; padding: 15px; margin: 5px">
        <div style="margin-bottom: 15px;">
            <h2 style="font-size: 18px; color: ${fontColor}; margin-bottom: 5px; font-weight: 700;">${userDetails.name}</h2>
            <p style="margin-bottom: 10px; margin-top: 0; color: #00000091;">${CardProfession}</p>
          </div>

      <div style="margin-top: 10px;">

        <!-- Phone -->
        <span style="display: flex; text-align: left; margin-top: 5px; border-bottom: 1px solid #0000001F; align-items: flex-start">
          <div style="margin-bottom: 1px; margin-right: 5px;">
            <img src=${SignEmailIcon} alt="E!" >
          </div>
          <p style="margin: 0;">${userDetails.phone}</p>
        </span>

        <!-- Email -->
        <span style="display: flex; text-align: left; margin-top: 5px; border-bottom: 1px solid #0000001F; align-items: flex-start">
          <div style="margin-bottom: 1px; margin-right: 5px;">
            <img src=${SignPhoneIcon} alt="P!" > 
          </div>
          <p style="margin: 0;">${userDetails.email}</p>
        </span>

        <!-- Website -->
        <span style="display: flex; text-align: left; margin-top: 5px; border-bottom: 1px solid #0000001F; align-items: flex-start">
          <div style="margin-bottom: 1px; margin-right: 5px;">
            <img src=${SignWebsiteIcon} alt="W!" > 
          </div>
          <p style="margin: 0;">${website}</p>
        </span>

        <!-- Location -->
        <span style="display: flex; text-align: left; margin-top: 5px; border-bottom: 1px solid #0000001F; align-items: flex-start">
          <div style="margin-bottom: 1px; margin-right: 5px;">
            <img src=${SignLocationIcon} alt="L!" > 
          </div>
          <p style="margin: 0;">${userDetails.location}</p>
        </span>
      </div>
    </div>
    </a>
    `;
    }
    return emailSignature;
  };

  // Function to render card content based on active link
  const renderCardContent = () => {
    let cardType = "";
    if (selectedCard === "Professional") cardType = "Business Card";
    else if (selectedCard === "Student") cardType = "Student Card";
    else if (selectedCard === "GenZ") cardType = "GenZ Card";
    else if (selectedCard === "Personal") cardType = "Personal Card";
    else cardType = `${selectedCard} ` + "Card";

    switch (activeLink) {
      case "content1":
        return (
          <div>
            <a
              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="digital-card"
                style={{
                  color: fontColor,
                  border: `1px solid ${borderColor}`,
                  fontStyle: fontStyle,
                  fontFamily: fontStyle,
                }}
              >
                <div className="default-card">
                  <h2 className="esign-Name" style={{ color: fontColor }}>
                    {userDetails.name}
                  </h2>
                  <span className="Profession ">{CardProfession}</span>
                  <div className="container-gift-1 mt-2">
                    <div>
                      <div className="circle-container">
                        <img src={CardProfilePic} alt="profile" />
                      </div>
                      {(selectedCard !== "Personal" ||
                        selectedCard !== "Customize_Personal") &&
                        cardLogo !== DefaultProfileBg && (
                          <div className="small-circle-container">
                            <img
                              className="companylogo"
                              src={cardLogo}
                              alt="company-alt"
                            />
                          </div>
                        )}
                    </div>
                    <div className="mt-5px">
                      <div className="Scanner-bng-image">
                        {/* <img src={userDetails.neoinwithqr} alt='qrcode' className='container-gift-1' /> */}
                        <a
                          href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                          rel="noopener noreferrer"
                        >
                          <QRCode
                            className="container-gift-1"
                            value={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                            style={{ width: 70, height: 70 }}
                          />
                        </a>
                      </div>
                      <span className="business-card">{cardType}</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        );
      case "content2":
        return (
          <div>
            <a
              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="digital-card digital-card-qrcode"
                style={{
                  color: fontColor,
                  border: `1px solid ${borderColor}`,
                  fontStyle: fontStyle,
                  fontFamily: fontStyle,
                }}
              >
                <div className="esign-card">
                  <div className="column-1">
                    <div>
                      <div className="circle-container">
                        <img src={CardProfilePic} alt="profile" />
                      </div>
                      {(selectedCard !== "Personal" ||
                        selectedCard !== "Customize_Personal") &&
                        cardLogo !== DefaultProfileBg && (
                          <div className="small-circle-container">
                            <img
                              className="companylogo"
                              src={cardLogo}
                              alt="company-alt"
                            />
                          </div>
                        )}
                    </div>

                    <div className="mt-1" style={{ width: "108px", textAlign: "center", alignItems: "center" }}>
                      <div className="Scanner-bng-image">
                        {/* <img src={userDetails.neoinwithqr} alt='qrcode' className='container-gift-1' /> */}
                        <a
                          href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <QRCode
                            className="container-gift-1"
                            value={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                            style={{ marginLeft: 15, width: 70, height: 70 }}
                          />
                        </a>
                      </div>
                      <span className="business-card">{cardType}</span>
                    </div>
                  </div>

                  <div className=" ms-2 column column-2">
                    <div className="mt-10px default-card">
                      <h2 className="esign-Name" style={{ color: fontColor }}>
                        {userDetails.name}
                      </h2>
                      <span className="Profession">{CardProfession}</span>
                    </div>

                    <div className="mt-20px">
                      <span className="digital-card-line border-bottom">
                        <PhoneIphoneIcon className="card-icon" />
                        <div className="text-content">{userDetails.phone}</div>
                      </span>
                      <span className="digital-card-line border-bottom">
                        <EmailIcon className="card-icon" />
                        <div className="text-content">{userDetails.email}</div>
                      </span>
                      <span className="digital-card-line border-bottom">
                        <PublicIcon className="card-icon" />
                        <div className="text-content">
                          {website}
                        </div>
                      </span>
                      <span className="digital-card-line">
                        <LocationOnIcon className="card-icon" />
                        <div className="text-content">
                          {userDetails.location}
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        );
      case "content3":
        return (
          <div>
            <a
              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="digital-card digital-card-profile"
                style={{
                  color: fontColor,
                  border: `1px solid ${borderColor}`,
                  fontStyle: fontStyle,
                  fontFamily: fontStyle,
                }}
              >
                <div className="d-flex flex-row ">
                  <div className="d-flex flex-column">
                    <div className="image-logo">
                      <div className="circle-container">
                        <img src={CardProfilePic} alt="profile" />
                      </div>
                      {(selectedCard !== "Personal" ||
                        selectedCard !== "Customize_Personal") && (
                          <div className="small-circle-container">
                            <img
                              className="companylogo"
                              src={cardLogo}
                              alt="company-alt"
                            />
                          </div>
                        )}
                    </div>

                    <span className="business-card mt-1">{cardType}</span>
                  </div>

                  <div className="d-flex flex-column justify-content-center text-center ms-2">
                    <div className="default-card ">
                      <h2 className="esign-Name" style={{ color: fontColor }}>
                        {userDetails.name}
                      </h2>
                      <span className="Profession mt-1">{CardProfession}</span>
                    </div>
                  </div>
                </div>

                <div className="save-design">
                  <span className="save-Contact">Save Contact</span>
                </div>
              </div>
            </a>
          </div>
        );
      case "content4":
        return (
          <div>
            <a
              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="digital-card digital-card-logo"
                style={{
                  color: fontColor,
                  border: `1px solid ${borderColor}`,
                  fontStyle: fontStyle,
                  fontFamily: fontStyle,
                }}
              >
                <div className="container-qrcodeprofile">
                  <div className="column-qrcodeprofile ">
                    <div className="mt-5px" style={{ width: "100px" }}>
                      <div className="Scanner-bng-image">
                        {/* <img src={userDetails.neoinwithqr} alt='qrcode' className='container-gift-1' /> */}
                        <a
                          href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <QRCode
                            className="container-gift-1"
                            value={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                            style={{ marginLeft: 15, width: 70, height: 70 }}
                          />
                        </a>
                      </div>
                      <span className="business-card">{cardType}</span>
                    </div>
                  </div>
                  <div className="column-qrcodeprofile ">
                    <div className="default-card">
                      <h2 className="esign-Name" style={{ color: fontColor }}>
                        {userDetails.name}
                      </h2>
                      <span className="Profession">{CardProfession}</span>
                    </div>
                  </div>
                  <div className="column-qrcodeprofile ms-2 text-center">
                    <div className="cir-container">
                      <img src={cardLogo} alt="logocompany" className="new" />
                    </div>
                  </div>
                </div>
                <span className="save-Contact-text">
                  <p className="save-contact-content mt-2">Save Contact</p>
                </span>
              </div>
            </a>
          </div>
        );
      case "content5":
        return (
          <div>
            <a
              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="digital-card digital-card-text-1"
                style={{
                  color: fontColor,
                  border: `1px solid ${borderColor}`,
                  fontStyle: fontStyle,
                  fontFamily: fontStyle,
                }}
              >
                <div className="default-card digital-identity-container-text">
                  <div className="mt-5px" style={{ width: "100px" }}>
                    <div className="Scanner-bng-image">
                      <a
                        href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <QRCode
                          className="container-gift-1"
                          value={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                          style={{ marginLeft: 15, width: 70, height: 70 }}
                        />
                      </a>
                    </div>
                    <span className="business-card">{cardType}</span>
                  </div>
                  <div className="save-design-1">
                    <span className="save-Contact">Save Contact</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        );
      case "content6":
        return (
          <div>
            <a
              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="digital-card digital-card-logo"
                style={{
                  color: fontColor,
                  border: `1px solid ${borderColor}`,
                  fontStyle: fontStyle,
                  fontFamily: fontStyle,
                }}
              >
                <div>
                  <div className="d-flex flex-row  align-items-center">
                    <div className="mt-5px">
                      <div className="content6-circle-container">
                        <img
                          src={cardLogo}
                          alt="logocompany"
                          className="content6-image-logo-container"
                        />
                      </div>
                      <span className="business-card ">{cardType}</span>
                    </div>

                    <div className="default-card m-2 ">
                      <h2 className="esign-Name" style={{ color: fontColor }}>
                        {userDetails.name}
                      </h2>
                      <span className="Profession">{CardProfession}</span>
                    </div>
                  </div>

                  <div className="save-design">
                    <span className="save-Contact">Save Contact</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        );
      case "content7":
        return (
          <div>
            <a
              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="digital-card digital-card-text"
                style={{
                  color: fontColor,
                  border: `1px solid ${borderColor}`,
                  fontStyle: fontStyle,
                  fontFamily: fontStyle,
                }}
              >
                <div className="default-card w-20">
                  <h2
                    className="esign-Name"
                    style={{ color: fontColor, }}
                  >
                    {userDetails.name}
                  </h2>
                  <span className="Profession">{CardProfession}</span>
                  <div>
                    <span className="mt-10px digital-card-line border-bottom">
                      <PhoneIphoneIcon className="card-icon" />
                      <div className="text-content">{userDetails.phone}</div>
                    </span>
                    <span className="digital-card-line border-bottom">
                      <EmailIcon className="card-icon" />
                      <div className="text-content">{userDetails.email}</div>
                    </span>
                    <span className="digital-card-line border-bottom">
                      <PublicIcon className="card-icon" />
                      <div className="text-content">{website}</div>
                    </span>
                    <span className="digital-card-line">
                      <LocationOnIcon className="card-icon" />
                      <div className="text-content">{userDetails.location}</div>
                    </span>
                  </div>
                </div>
                <span className="save-Contact-text">
                  <p className="save-contact-content">Save Contact</p>
                </span>
              </div>
            </a>
          </div>
        );
      default:
        return null;
    }
  };

  const sliderSettings = {
    infinite: cards.length > 1,
    slidesToShow: cards.length >= 4 ? 4 : cards.length,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 4000,
    nextArrow: (
      <ArrowForwardIosRoundedIcon className="icon-clor" color="#0044C6" />
    ),
    prevArrow: <ArrowBackIosRoundedIcon className="icon-color" />,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: cards.length >= 3 ? 3 : cards.length,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: cards.length >= 2 ? 2 : cards.length,
        },
      },
    ],
  };
  if (loading) {
    return <EmailSignatureSkeleton />
  }

  return (
    <>
      <div className="digital-identity-container">
        {/* Image */}
        {!lightboxOpen && (
          <>
            <div
              className="top-images d-flex"
              style={{ height: "300px", width: "80%" }}
            >
              <Box className="digital_identity_Carousel profile-offers-box my-2">
                <Slider {...sliderSettings} sx={{ backgroundColor: "#f4f7fe" }}>
                  {cards.map((cardType, index) => {
                    const data = cardDetailsAll?.find((state) => state?.CardName === cardType);
                    const styles = cardStylesAll?.find((state) => state?.CardName === cardType);
                    // const data = cardDetailsAll[cardType];
                    // const styles = cardStylesAll[cardType];
                    // console.log("STYLES", styles);
                    let profilePicture = data?.profile_pic || DefaultProfileBg;
                    let cardLogo = data?.logo || DefaultProfileBg;

                    return data ? (
                      <motion.div
                        key={cardType}
                        className={`digi-card card-professional ${selectedCard === cardType ? "selected-card" : ""}`}
                        style={{
                          backgroundColor: styles?.bgColor || "white"
                        }}
                        onClick={() => handleCardClick(cardType)}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.2, duration: 0.5 }}
                      >
                        <div
                          className="digi-card-upper"
                          style={{
                            backgroundImage: `url(${profilePicture})`,
                            backgroundColor: styles?.bgColor || "white"
                          }}
                        >
                          <div
                            className="digi-card-label-container"
                            style={{ background: styles?.colorLayout || "#0044c6" }}
                          >
                            {/* <span className="digi-card-label" style={{ backgroundColor: `styles?.colorLayout || "#0044c6"` }}>{cardType}</span> */}
                            <span className="digi-card-label" >
                              {cardType}
                            </span>
                          </div>

                          {cardType === "Personal" ? (
                            <CardWaveSmile
                              bgColor={"#ffffff"}
                              strokeColor={styles?.colorLayout || "#0044c6"}
                            />
                          ) : (
                            <CardWaveStd
                              bgColor={"#ffffff"}
                              strokeColor={styles?.colorLayout || "#0044c6"}
                            />
                          )}

                          {cardType !== "Personal" && (
                            <div className="company-logo-container flex-center">
                              <img
                                src={cardLogo}
                                alt="Company"
                                className="prof-company-logo"
                              />
                            </div>
                          )}
                        </div>
                        <div className="digi-card-lower" style={{
                          backgroundColor: "white"
                        }} >
                          <h2 className="digi-card-Name truncate">
                            {userDetails.name}
                          </h2>
                          <span className="Profession">
                            {cardType === "Professional"
                              ? data?.designation
                              : data?.title}
                          </span>
                        </div>
                      </motion.div>
                    ) : null;
                  })}
                </Slider>
              </Box>
            </div>
            {/* Links */}
            <motion.div className="rectangle" initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, ease: "easeOut" }}>
              <div className="left-div">
                <ul>
                  <li
                    className={activeLink === "content1" ? "active" : ""}
                    onClick={() => handleLinkClick("content1")}
                  >
                    Default
                  </li>
                  <li
                    className={activeLink === "content2" ? "active" : ""}
                    onClick={() => handleLinkClick("content2")}
                  >
                    QR Based
                  </li>
                  {selectedCard !== "Personal" ||
                    selectedCard !== "Customize_Personal" ? (
                    <li
                      className={activeLink === "content3" ? "active" : ""}
                      onClick={() => handleLinkClick("content3")}
                    >
                      Profile + Logo
                    </li>
                  ) : (
                    <li
                      className={activeLink === "content3" ? "active" : ""}
                      onClick={() => handleLinkClick("content3")}
                    >
                      Profile
                    </li>
                  )}
                  {(selectedCard !== "Personal" ||
                    selectedCard !== "Customize_Personal") && (
                      <li
                        className={activeLink === "content4" ? "active" : ""}
                        onClick={() => handleLinkClick("content4")}
                      >
                        QRCode + Logo
                      </li>
                    )}
                  <li
                    className={activeLink === "content5" ? "active" : ""}
                    onClick={() => handleLinkClick("content5")}
                  >
                    QRCode
                  </li>
                  {(selectedCard !== "Personal" ||
                    selectedCard !== "Customize_Personal") && (
                      <li
                        className={activeLink === "content6" ? "active" : ""}
                        onClick={() => handleLinkClick("content6")}
                      >
                        Logo
                      </li>
                    )}
                  <li
                    className={activeLink === "content7" ? "active" : ""}
                    onClick={() => handleLinkClick("content7")}
                  >
                    Text
                  </li>
                </ul>
              </div>

              <div className="container-digital-card">
                <div className="column1-digital">
                  <div className="right-div">{renderCardContent()}</div>
                </div>

                <div className="column2-digital">
                  <div className="content-and-options">
                    <div className="customization-options">
                      <p className="description-content">Customise</p>
                      <div className="color-options">
                        <p className="mt-10px description-content">
                          Font Color
                        </p>
                        {predefinedFontColors.map((color, index) => (
                          <div
                            key={index}
                            className="color-option"
                            style={{ backgroundColor: color }}
                            onClick={() => handleFontColorChange(color)}
                          ></div>
                        ))}
                      </div>
                      <div className="mt-10px color-options">
                        <p className="description-content">Card Border Color</p>
                        {predefinedBorderColors.map((color, index) => (
                          <div
                            key={index}
                            className="color-option"
                            style={{ backgroundColor: color }}
                            onClick={() => handleBorderColorChange(color)}
                          ></div>
                        ))}
                      </div>

                      <div className="mt-10px dropdown-container">
                        <FormControl>
                          <div className="">
                            <p className="description-content mt-5px">
                              TypeFace
                            </p>
                          </div>
                          <Select
                            value={fontStyle}
                            onChange={(e) => setFontStyle(e.target.value)}
                          >
                            {fontStyleOptions.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <button
                        className="mt-20px Add-to-Email mb-154"
                        onClick={handleClick}
                      >
                        Add to Email
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>{" "}
          </>
        )}
        <Lightbox
          isOpen={lightboxOpen}
          handleClose={handleCloseLightbox}
          selectedCard={selectedCard}
          objectId={objectId}
          emailSignature={generateEmailSignature()}
          renderCardContent={renderCardContent}
        />
      </div >
    </>
  );
};

export default DigitalIdentity;
